// extracted by mini-css-extract-plugin
export default {"hi_user":"sidebar_hi_user__cSKEa","go_premium":"sidebar_go_premium__V7iAr","ImgActive":"sidebar_ImgActive__Ewnug","imgNotActive":"sidebar_imgNotActive__MnJiW"};